import { style } from "@vanilla-extract/css";

export const buttonStyle = style({
  // Keep
});
